import React, { useEffect, useState } from "react";
import cssStyle from "./maincard.module.css";
import { Breadcrumb, Divider, Tabs, Tooltip, Typography } from "antd";
import HeadCard from "./head";
import RankList from "./ranklist";
import RankListMulti from "./ranklistmulti";
import JoinAndTeam from "./joinandteam";
import { Problem } from "./problem";
import { Link, useHistory, useLocation } from "react-router-dom";
import jwt, { JwtPayload } from "jsonwebtoken";
import {
  fetchOneTrack,
  TrackModel,
} from "../../api/track";
import { useAppSelector } from "../../store/hook";
import { fetchOneStage, StageModel } from "../../api/stage";
import { getContest, ContestModel } from "../../api/contest";

import ReactMarkdownPreview from "@uiw/react-markdown-preview";
import { fetchProblems, ProblemModel } from "../../api/problem";
import { useTranslation } from 'react-i18next';
import { t } from "i18next";
interface IPropCard {
  contestId: number;
  trackId: number;
  ssid?: number;
  track: TrackModel;
  contest: ContestModel;
  stages: Record<number, StageModel>;
}

const { Title } = Typography;
const { TabPane } = Tabs;

export const MainCard: React.FunctionComponent<IPropCard> = (
  prop: IPropCard
) => {
  const { contestId, trackId, ssid, track, stages, contest } = prop;

  const location = useLocation();
  const history = useHistory();
  const [stageId, setStageId] = useState(ssid || track.nowStage);
  const key = useAppSelector((state) => state.user.key);
  const id = useAppSelector(
    (state) => (jwt.decode(state.user.key) as JwtPayload)?.id || 0
  );
  const [problems, setProblems] = useState<ProblemModel[]>([]);
  const [stage, setStage] = useState(stages[stageId]);
  const [showteam, setShowteam] = useState(-1);
  useEffect(() => {
    for(var tag of JSON.parse(track?.tags||"[]") as string[])
    {
      if(tag.split(":")[0] == "参赛队伍")
        setShowteam(Number(tag.split(":")[1]));
    //console.log(JSON.parse(track?.tags||"[]"),tag,showteam);
    }
    if (contestId === -1 || trackId === -1) {
      history.push("/404");
    } else {
      setStage(stages[stageId]);
      setactiveKey(`article-${contest?.articles[0].id}`);
      fetchProblems(contestId, trackId, stageId)
        .then((data) => {
          setProblems(data);
          setactiveKey(`problem-${data[0].id}`);
        })
        .catch((err) => {
          console.log(err);
          setProblems([]);
        });
    }
  }, [location, key, id, history, contestId, trackId, stageId, stages,ssid]);

  const [activeKey, setactiveKey] = useState("");

  return (
    <div className={cssStyle.card}>

      <HeadCard
        title={track?.title || ""}
        imageUrl={track?.imgSrc || ""}
        description={track?.intro || ""}
        tags={JSON.parse(track?.tags||"[]") as string[]}
        team={showteam >= 0?showteam:{"38":2036,"39":2206,"40":2243}[track?.id]||track?.users || 0}
        prize={(track?.prize.toString())||"敬请期待"}
        startDate={track?.stageStartTime || new Date("2021-01-01").getTime()}
        endDate={track?.stageEndTime || new Date("2021-12-31").getTime()}
        midDate={track?.stageTimeline || {}}
        track={track}
        stages={stages}
        stageEndTime={stage?.configEndTime*1000||0}
      />


      <Tabs className={cssStyle.mainCardTab} tabPosition="left" activeKey={activeKey} onTabClick={(key) => {
        setactiveKey(key)
      }}>
        {contest?.articles.map((article) => {
          const tabTitle = `${article.title.split(":").length>1?article.title.split(":")[0]:article.title}`;
          const tabM = tabTitle.length > 6 ? `${tabTitle.substr(0, 6)}...` : tabTitle;
          return(
            article.title.substr(0,2) === "隐藏"?null:
            (
              <TabPane
                key={`article-${article.id}`}
                tab={<Tooltip title={tabTitle}>{tabM}</Tooltip>}
                className={cssStyle.tabpaneMainCard}
              >
                <div className="site-layout-content">
                  <Title level={2}>{article.title.split(":").length>1?article.title.split(":")[1]:article.title}</Title>
                  <Divider />
                  <ReactMarkdownPreview source={article.body} />
                </div>
              </TabPane>
            )
          )
        })}
        {track?.articles.map((article) => {
          const tabTitle = `${article.title.split(":").length>1?article.title.split(":")[0]:article.title}`;
          const tabM = tabTitle.length > 6 ? `${tabTitle.substr(0, 6)}...` : tabTitle;
          return (
            <TabPane
              key={`article-${article.id}`}
              tab={<Tooltip title={tabTitle}>{tabM}</Tooltip>}
              className={cssStyle.tabpaneMainCard}
            >
              <div className="site-layout-content">
                <Title level={2}>{article.title.split(":").length>1?article.title.split(":")[1]:article.title}</Title>
                <Divider />
                <ReactMarkdownPreview source={article.body} />
              </div>
            </TabPane>
          )
        })}
        <TabPane tab={t("报名 组队")} key="team" className={cssStyle.tabpaneMainCard}>
          <JoinAndTeam
            contestId={contestId}
            trackId={trackId}
            trackStatus={track?.configTrackStatus}
          />
        </TabPane>
        {problems.map((problem) => {
          const tabTitle = t("题目")/*${problem.title}`*/;
          const tabM = tabTitle.length > 10 ? `${tabTitle.substr(0, 9)}...` : tabTitle;
          return (
            <TabPane
              key={`problem-${problem.id}`}
              tab={<Tooltip title={tabTitle}>{tabM}</Tooltip>}
              className={cssStyle.tabpaneMainCard}
            >
              <Problem
                {...{ contestId, trackId, stageId }}
                problemId={problem.id}
                problem={problem}
              />
            </TabPane>
          )
        })}
        {/* <TabPane tab="提交" key="submit" className={cssStyle.tabpaneMainCard}>
          <ProblemList
            contestId={contestId}
            trackId={trackId}
            stageId={stage?.id || -1}
          />
        </TabPane> */}
        {
              stage?.configShowRank?(
                ((stage?.problems.length)==1)?
              (
              <TabPane tab={t("排行")} key="rank" className={cssStyle.tabpaneMainCard}>
                <RankList
                  {...{ contestId, trackId, stageId }} />
              </TabPane>
              ):(
              <TabPane tab={t("多题目排行榜"+stage?.problems.length)} key="rank" className={cssStyle.tabpaneMainCard}>
                <RankListMulti
                  {...{ contestId, trackId, stageId }} />
              </TabPane>)
              ):(<TabPane tab={t("排行（未开放）")} key="rank" className={cssStyle.tabpaneMainCard}>
            </TabPane>)
        }
        {/*stage?.articles.map((article) => {
          const tabTitle = `${article.title}`;
          const tabM = tabTitle.length > 6 ? `${tabTitle.substr(0, 5)}...` : tabTitle;
          return (
            <TabPane
              key={`article-${article.id}`}
              tab={<Tooltip title={tabTitle}>{tabM}</Tooltip>}
              className={cssStyle.tabpaneMainCard}
            >
              <div className="site-layout-content">
                <Title level={2}>{article.title}</Title>
                <Divider />
                <ReactMarkdownPreview source={article.body} />
              </div>
            </TabPane>
          )
        })*/}
      </Tabs>
    </div>
  );
};

export default MainCard;
